import { render, staticRenderFns } from "./NarrativeEditor.vue?vue&type=template&id=4a6d1290&scoped=true&"
import script from "./NarrativeEditor.vue?vue&type=script&lang=js&"
export * from "./NarrativeEditor.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeEditor.vue?vue&type=style&index=0&id=4a6d1290&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d1290",
  null
  
)

export default component.exports